export const approveAdvisoryText = `This will display this review on its facility's page on the website.
If needed, you can remove this review later via its facility's section in the application.`;

export const denyAdvisoryText = `This will deny this review from being displayed on its facility's page.
It will remain in this queue until the end of the day if you would like to enable it later.`;
